import React, { useEffect, useState } from 'react'
import Heading from '../../Components/common/table/Tableheading';
import { showData } from '../../Utils/APIs/commonShowAPI';
import { FaRegWindowClose } from "react-icons/fa";
import axios from 'axios';
const ComplaintList = () => {
    const headingList = [
        '#',
        'saral id',
        'Farmer name',
        'Service Request Id',
        'status',
        'complaint Details',
        'closure comment',
        'region',
        'zone',
        'circle',
        'division',
        'sub-division',
        'Complaint register DatE',
        'Last update Date'
    ]
    const [complaintList , setComplaintList] = useState([]);
    const [selectedComplaint, setSelectedComplaint] = useState(null);
    const [showModal, setShowModal] = useState(false);
    // for update complaint
    const [isConsumerContacted, setIsConsumerContacted] = useState(null);
    const [complaintCloseData,setComplaintCloseData] = useState(null);
    const [reloadComplaint, setReloadComplaint] = useState(false);
    const [updateResponse, setUpdateResponse] = useState(null);
    useEffect(()=>{
        showData('MSEDCL/complaint', setComplaintList);
        setReloadComplaint(false);
    },[reloadComplaint]);

    const handleRowClick = (complaint) => {
        console.log("complaint ->", complaint)
        setSelectedComplaint(complaint);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedComplaint(null);
        setUpdateResponse(null);
        setComplaintCloseData(null);
        setIsConsumerContacted(null);
    };
    const updateComplaint = async()=>{
        if(complaintCloseData === null){
            setUpdateResponse("Complaint closer details are required.")
            return;
        }
        if(isConsumerContacted === null){
            setUpdateResponse("Please select consumer connected field")
            return;
        }
        const data = {
            saralId: selectedComplaint.beneficiaryid,
            serviceRequestId : selectedComplaint?.servicereqid,
            isConsumerContacted:isConsumerContacted,
            closureComment:complaintCloseData,
            created_dt:selectedComplaint?.created_dt
        }
        try {
             const response = await axios.post(
                // `${process.env.REACT_APP_API_URL}/MSEDCL/complaintClose`, 
                `${process.env.REACT_APP_API_URL}/MSEDCL/request-close-complaint`,
                data
            )
            if(response?.data){
                setUpdateResponse(response?.data?.message)
            }
        } catch (error) {
            setUpdateResponse(error?.response?.data?.message)
        }
        setReloadComplaint(true);
    }
    return (
        <div className='h-[calc(100vh-5rem)] w-full'>
            <div>
                <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50 rounded-lg">
                M<span className="text-lg">AHARASHTRA </span> C
                <span className="text-lg">OMPLAINT</span> L
                <span className="text-lg">IST</span>
                </h1>
            </div>
            <div className='w-full overflow-scroll h-[calc(100vh-9rem)]'>
                <table className='w-full border-collapse text-center'>
                    <Heading list={headingList} />
                        {
                            complaintList.length > 0 && complaintList.map((complaint, index) => {
                                const {
                                    beneficiaryid, 
                                    consumername, 
                                    servicereqid,
                                    current_status,
                                    request_details,
                                    closure_comment,
                                    region,
                                    zone,
                                    circle,
                                    div,
                                    subdiv,
                                    created_dt,
                                    updated_dt,
                                } = complaint;
                                return(
                                <tbody 
                                    key={servicereqid || index}
                                    className="bg-white border-b hover:bg-gray-100 hover:text-gray-900 w-full cursor-pointer"
                                    onClick={() => {
                                        if(current_status !== 'Closed'){
                                            handleRowClick(complaint)
                                        }else alert("Complaint already closed.")
                                    }}
                                >
                                    <tr>
                                        <td className="px-2 h-16 text-center text-sm">{index + 1}</td>
                                        <td className="px-2 h-16 text-center text-sm">{beneficiaryid}</td>
                                        <td className="px-2 h-16 text-center text-sm">{consumername}</td>
                                        <td className="px-2 h-16 text-center text-sm">{servicereqid}</td>
                                        <td className="px-2 h-16 text-center text-sm">{current_status}</td>
                                        <td className="px-2 h-16 text-center text-sm">{request_details}</td>
                                        <td className="px-2 h-16 text-center text-sm">{closure_comment}</td>
                                        <td className="px-2 h-16 text-center text-sm">{region}</td>
                                        <td className="px-2 h-16 text-center text-sm">{zone}</td>
                                        <td className="px-2 h-16 text-center text-sm">{circle}</td>
                                        <td className="px-2 h-16 text-center text-sm">{div}</td>
                                        <td className="px-2 h-16 text-center text-sm">{subdiv}</td>
                                        <td className="px-2 h-16 text-center text-sm">{created_dt}</td>
                                        <td className="px-2 h-16 text-center text-sm">{updated_dt}</td>
                                    </tr>
                                </tbody>
                                )
                            })
                        }
                </table>
            </div>

            {/* Modal */}
            {showModal && selectedComplaint && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded shadow-lg min-w-[300px] max-w-[90vw] relative">
                        <button
                            className="absolute top-2 right-2 text-white rounded"
                            onClick={closeModal}
                            style={{ zIndex: 10 }}
                        >
                            <FaRegWindowClose color="red" size={24} />
                        </button>
                        <h2 className="text-xl font-bold mb-4">Complaint Details</h2>
                        <pre className="text-sm p-2 rounded overflow-x-auto">
                           {selectedComplaint.beneficiaryid}-{selectedComplaint.consumername}
                            {/* {JSON.stringify(selectedComplaint, null, 2)} */}
                        </pre>
                            <div>
                                <label for="HP" className="block mb-2 text-sm font-medium text-gray-900 ">Consumer Connected </label>
                                 <select 
                                 name='HP'
                                 onChange={(e)=>{setIsConsumerContacted(e.target.value)}}
                                 defaultValue={isConsumerContacted}
                                     className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm   block w-full p-2.5 ">
                                    <option value=''>-- Select --</option>
                                    <option value="Y">Yes</option>
                                    <option value="N">No</option>
                                 </select>
                            </div>
                            <div className='pt-4'>
                                <label for="HP" className="block mb-2 text-sm font-medium text-gray-900 ">Complaint Resolved</label>
                                 <select 
                                 name='HP'
                                 onChange={(e)=>{setIsConsumerContacted(e.target.value)}}
                                 defaultValue={isConsumerContacted}
                                     className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm   block w-full p-2.5 ">
                                    <option value=''>-- Select --</option>
                                    <option value="Y">Yes</option>
                                    <option value="N">No</option>
                                 </select>
                            </div>
                            <div className='pt-4'>
                                <label for="closer" className="block mb-2 text-sm font-medium text-gray-900 ">Complaint Close Details </label>
                                <textarea 
                                    id="closer" 
                                    onChange={(e) => { setComplaintCloseData(e.target.value) }} 
                                    value={complaintCloseData} 
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  block w-full p-2.5 h-24 resize-none" 
                                    placeholder="complaint closure details" 
                                    required 
                                />
                            </div>
                            <button
                            className="mt-4 text-white rounded bg-blue-600 p-2 px-4"
                            onClick={updateComplaint}
                        >
                            Submit
                        </button>
                        <p className='text-red-600'>{updateResponse !== null && updateResponse}</p>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ComplaintList